"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var util_1 = require("~/js/lib/util/util");
var frame_1 = require("./frame");
var LOCAL_NAME = 'yy_watchHistory';
var EFFECTIVE_DURATION = 14 * 24 * 60 * 60 * 1000;
var MAX_RECORD_COUNT = 30;
var History = (function () {
    function History() {
        this.source = {};
        this.historys = [];
        this.frameRequired = window.location.protocol !== 'https:';
        this.frame = new frame_1.Frame();
    }
    History.prototype.init = function (uid) {
        return __awaiter(this, void 0, void 0, function () {
            var iUid, historyObj, historys, historyObjStr, now;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (uid === 0) {
                            iUid = 'anony';
                        }
                        else {
                            iUid = "" + uid;
                        }
                        historyObj = {};
                        historys = [];
                        historyObjStr = '';
                        if (!this.frameRequired) return [3, 2];
                        return [4, this.frame.getItem(LOCAL_NAME)];
                    case 1:
                        historyObjStr = _a.sent();
                        return [3, 3];
                    case 2:
                        historyObjStr = util_1.localStorage.getItem(LOCAL_NAME);
                        _a.label = 3;
                    case 3:
                        if (!historyObjStr) {
                            historyObjStr = '{}';
                        }
                        try {
                            historyObj = JSON.parse(util_1.localStorage.getItem(LOCAL_NAME) || '{}');
                        }
                        catch (er) {
                            historyObj = {};
                        }
                        if (historyObj[iUid]) {
                            historys = historyObj[iUid];
                        }
                        now = new Date();
                        historys = historys.filter(function (item) {
                            var pre = new Date(item.expires);
                            if (isNaN(pre.getTime())) {
                                return false;
                            }
                            return now.getTime() - pre.getTime() < EFFECTIVE_DURATION;
                        });
                        if (historys.length > MAX_RECORD_COUNT) {
                            historys.length = MAX_RECORD_COUNT;
                        }
                        this.historys = historys;
                        this.source = historyObj;
                        this.uid = iUid;
                        return [2];
                }
            });
        });
    };
    History.prototype.add = function (op) {
        return __awaiter(this, void 0, void 0, function () {
            var i, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        for (i = 0; i < this.historys.length;) {
                            item = this.historys[i];
                            if (item.topCid === op.sid && item.subCid === op.ssid) {
                                this.historys.splice(i, 1);
                            }
                            else {
                                i++;
                            }
                        }
                        this.historys.unshift({
                            topCid: op.sid,
                            subCid: op.ssid,
                            roomName: encodeURIComponent(op.roomName),
                            expires: +new Date()
                        });
                        if (this.historys.length > MAX_RECORD_COUNT) {
                            this.historys.length = MAX_RECORD_COUNT;
                        }
                        this.source[this.uid] = this.historys;
                        return [4, this.save()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    History.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.frameRequired) return [3, 2];
                        return [4, this.frame.setItem(LOCAL_NAME, JSON.stringify(this.source))];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        util_1.localStorage.setItem(LOCAL_NAME, JSON.stringify(this.source));
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    return History;
}());
exports.History = History;
